import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  // SEMPRE modo escuro - não verificar localStorage ou preferência do sistema
  const [darkMode, setDarkMode] = useState(true);

  useEffect(() => {
    // Sempre aplicar classe dark
    document.documentElement.classList.add('dark');
    // Forçar no localStorage também
    localStorage.setItem('vibeday-dark-mode', 'true');
  }, []);

  // toggleDarkMode mantido para compatibilidade mas não faz nada
  const toggleDarkMode = () => {
    // Desabilitado - sempre modo escuro
  };

  return (
    <ThemeContext.Provider value={{ darkMode: true, toggleDarkMode }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
